import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { DealerLocationDMSIncadeaConfig } from "models";
import type { AddEditLocationFormPayload } from "modules/DMSv3/Settings/components";

export type IncadeaConfig = Pick<
  DealerLocationDMSIncadeaConfig,
  "dms_dealer_id" | "dms_appointment_type" | "dms_warranty_intervention_id" | "dms_internal_intervention_id"
>;

type IncadeaConfigSectionProps = {
  index: number;
};

const FormHelper = createFormHelper<AddEditLocationFormPayload>();

export const IncadeaConfigSection = ({ index }: IncadeaConfigSectionProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid columns="equal">
        <GridColumn>
          <Form.Field>
            <label>{t("v8_dms_dealer_id", "DMS Dealer ID")} </label>
            <FormHelper.Field.ArrayInput fieldArrayName="dealer_location_dms" fieldKey="incadea_config.dms_dealer_id" index={index} inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_dms_appointment_type", "DMS Appointment Type")} </label>
            <FormHelper.Field.ArrayInput fieldArrayName="dealer_location_dms" fieldKey="incadea_config.dms_appointment_type" index={index} inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_dms_warranty_intervention_id", "DMS Warranty Intervention ID")} </label>
            <FormHelper.Field.ArrayInput
              fieldArrayName="dealer_location_dms"
              fieldKey="incadea_config.dms_warranty_intervention_id"
              index={index}
              inputProps={{ fluid: true }}
            />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_dms_internal_intervention_id", "DMS Internal Intervention ID")} </label>
            <FormHelper.Field.ArrayInput
              fieldArrayName="dealer_location_dms"
              fieldKey="incadea_config.dms_internal_intervention_id"
              index={index}
              inputProps={{ fluid: true }}
            />
          </Form.Field>
        </GridColumn>
      </Grid>
    </>
  );
};
